export class WeekDayName {
  constructor(
    dayOnWeek: number,
    summaryName: string,
    name: string,
  ) {
    this.dayOnWeek = dayOnWeek;
    this.summaryName = summaryName;
    this.name = name;
  }
  public dayOnWeek: number;
  public summaryName: string;
  public name: string;
}
